import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { createPostponeDealSchema, defaultFormValues } from './form.schema';

import type { TPostponeDealFormInput, TPostponeDealFormState } from './form.schema';

export const usePostponeDealForm = () => {
    const { t } = useTranslation();
    const postponeDealSchema = createPostponeDealSchema(t);
    const {
        clearErrors,
        control,
        handleSubmit,
        reset,
        formState: { isSubmitting, isValid },
    } = useForm<TPostponeDealFormInput, unknown, TPostponeDealFormState>({
        resolver: zodResolver(postponeDealSchema),
        defaultValues: defaultFormValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const resetForm = () => {
        reset(defaultFormValues);
    };

    return {
        clearErrors,
        control,
        handleSubmit,
        isSubmitting,
        isValid,
        resetForm,
    };
};
